import Auth0Landing from "./auth0";

export default Auth0Landing;
